/**
 * Returns the last 5 words of the given query, trimmed and in lowercase.
 */
export function getQueryToSearch(query) {
    return query.trim().toLowerCase().split(/\s+/).slice(-5).join(' ');
}
/**
 * Checks if the query contains the given term as a whole word (not as a substring).
 * For example, "boxmania" does NOT match the term "box", but "box tips" does.
 */
export function queryIncludesWholeWord(query, term) {
    const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp(`(?:^|[^a-z0-9])${escaped}(?:[^a-z0-9]|$)`).test(query);
}
//# sourceMappingURL=getQueryToSearch.js.map